import { isCanUseCallSettings } from 'util/getCallType';
import { VCS_JOIN_POLICY } from 'consts';
import { canBypassWaitingRoomOnReconnect } from 'features/AccessRequests/utils/canBypassWaitingRoom';
import { selectIsAuthorized } from 'state/selectors';
import { hasMeetMessengerBootstrapInSession } from '../bootstrap/messengerMeet';
import { resolveEffectiveJoinPolicy } from '../policy';
import { getWaitingListId, isHasWaitingListId } from './session';

/** Нужен joinCallByLink(OAuth) вместо быстрого входа по кэшу JWT из session. */
export const mustJoinThroughWaitingRoomApi = (roomId: string): boolean => {
    if (isHasWaitingListId()) {
        return true;
    }

    if (canBypassWaitingRoomOnReconnect(roomId)) {
        return false;
    }

    if (!isCanUseCallSettings()) {
        return false;
    }

    const joinPolicy = resolveEffectiveJoinPolicy();
    if (joinPolicy === VCS_JOIN_POLICY.ALL_WITH_APPROVAL) {
        return true;
    }
    if (joinPolicy === VCS_JOIN_POLICY.GUESTS_WITH_APPROVAL) {
        return !selectIsAuthorized();
    }
    return false;
};

export type JoinAttemptPlan =
    | { kind: 'empty_name' }
    | { kind: 'fast_reconnect' }
    | { kind: 'poll_skip_no_id' }
    | { kind: 'api_join'; waitingListId?: string };

export type ResolveJoinAttemptParams = {
    pollOnly: boolean;
    cleanName: string;
    roomId: string;
    isWaitingForApproval: boolean;
};

/** Чистая логика: fast reconnect, poll skip или join API. */
export const resolveJoinAttempt = ({
    pollOnly,
    cleanName,
    roomId,
    isWaitingForApproval,
}: ResolveJoinAttemptParams): JoinAttemptPlan => {
    if (!cleanName) {
        return { kind: 'empty_name' };
    }

    const sessionWaitingListId = getWaitingListId();
    const isWaitingSession = isWaitingForApproval || Boolean(sessionWaitingListId);

    if (isWaitingForApproval && !sessionWaitingListId) {
        return pollOnly ? { kind: 'poll_skip_no_id' } : { kind: 'api_join' };
    }

    if (!isWaitingSession && canBypassWaitingRoomOnReconnect(roomId) && !hasMeetMessengerBootstrapInSession()) {
        return { kind: 'fast_reconnect' };
    }

    return {
        kind: 'api_join',
        waitingListId: isWaitingSession || isHasWaitingListId() ? sessionWaitingListId : undefined,
    };
};
